<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <ng-container *transloco="let t">
        <div class="crooked-card-header">
            <h2 mat-dialog-title>{{ t('LANGUAGE') }}</h2>
        </div>
        <mat-dialog-content>
            <mat-radio-group formControlName="language">
                @for (language of languages; track language.code) {
                    <mat-radio-button [value]="language.code">{{ language.name }}</mat-radio-button>
                }
            </mat-radio-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button mat-dialog-close type="button">{{ t('CANCEL') }}</button>
            <button mat-flat-button type="submit">{{ t('SAVE') }}</button>
        </mat-dialog-actions>
    </ng-container>
</form>
